<template>
    <div>
        <v-card-text v-if="loading" text-center>
            <v-progress-circular
            indeterminate
            size="64"
            width="7"
            color="primary"
            ></v-progress-circular>
        </v-card-text>
        <v-container class="ma-0 pa-0" v-else>
            
            <v-row no-gutters>
                <v-col cols="12">
                    <v-tabs v-model="tab">
                        <v-tab
                            key="selected">
                            strumenti selezionati
                        </v-tab>
                        <v-tab
                            v-if="op_type != 'leg'"
                            v-can="{obj_type:'operation', action: 'add_instr'}"
                            key="selection">
                            scelta strumenti
                        </v-tab>
                    </v-tabs>
                    <v-tabs-items v-model="tab">
                        <v-tab-item key="selected">
                            <v-container class="pa-0 ma-0">
                                <v-row no-gutters v-for="instr_id in instrument_ids" :key="instr_id">
                                    <OpInstrumentItem
                                        :instrument_id="instr_id"
                                        :override_location="all_instrument"
                                        :location="location"
                                        :show_platform_capacity="true"
                                        :key="instr_id">
                                        <template v-slot:item_action>
                                            <v-btn 
                                                :disabled="locked_instr.includes(instr_id)"
                                                fab
                                                small
                                                color="action"
                                                class="ma-2" 
                                                @click="removeInstrumentFromSelection(instr_id)">
                                                <v-icon>delete</v-icon>
                                            </v-btn>
                                        </template>
                                    </OpInstrumentItem>
                                </v-row>
                            </v-container>
                        </v-tab-item>
                        <v-tab-item key="selection"
                        v-can="{obj_type:'operation', action: 'add_instr'}"
                        >
                            <v-container class="pa-2 pa-0 ma-0">
                                <v-row no-gutters>
                                    <v-col cols="8">
                                        <v-checkbox dense 
                                        label="tutte le sedi" 
                                        v-model="all_instrument"
                                        />
                                    </v-col>
                                    <v-col cols="4" class="d-flex pl-4 justify-end">
                                        <v-btn 
                                            v-can="{obj_type:'operation', action: 'add_instr'}"
                                            text @click="addNewInstrument"><v-icon small class="ma-1">add_box</v-icon>strumento
                                        </v-btn>
                                    </v-col>    
                                </v-row>
                                <v-row no-gutters class="py-2" v-if="!all_instrument">
                                    <v-col cols="8">
                                        <span v-if="!Object.values(location.departments).length > 0">nessun reparto</span>
                                        <v-autocomplete v-else dense outlined
                                            v-model="department_ids"
                                            label="reparto"
                                            :items="Object.values(location.departments)"
                                            item-text="name" 
                                            item-value="id"
                                            @change="updateSearch"
                                            multiple
                                            clearable
                                        />
                                    </v-col>
                                    <v-col cols="4" class="d-flex pl-4 justify-end">
                                        <v-btn text @click="addNewDepartment"><v-icon small class="ma-1">add_box</v-icon>reparto</v-btn>
                                    </v-col>
                                </v-row>
                        
                                <!------------------------------------------------------------------>
                                <div v-if="advanced_search">
                                <v-divider />
                                <v-row no-gutters>
                                    <v-col cols="12" class="d-flex flex-row justify-space-between align-content-center">
                                        <span class="text-h6">Ricerca avanzata</span>
                                        <span><v-btn fab small text @click.stop="cancelSearch()"><v-icon>close</v-icon></v-btn></span>
                                    </v-col>
                                </v-row>
                                <v-row no-gutters>
                                    <v-col cols="4" v-if="all_instrument && locations.length > 0" class="d-flex justify-start align-content-center pr-2">
                                        <v-autocomplete dense outlined
                                                label="sede"
                                                v-model="filter.location_id"
                                                :items="locations"
                                                item-value="id"
                                                item-text="value.name"
                                                clearable
                                                @change="getDepartments"
                                            ></v-autocomplete>
                                    </v-col>
                                    <v-col v-if="all_instrument && locations.length > 0 && filter.location_id && departments.length > 0" cols="4" class="d-flex justify-start align-content-center">
                                        <v-autocomplete dense outlined
                                                label="reparto"
                                                v-model="filter.department_id"
                                                :items="departments"
                                                item-value="id"
                                                item-text="name"
                                                clearable
                                            ></v-autocomplete>
                                    </v-col>
                                </v-row>
                                <v-row no-gutters>
                                    <v-col cols="6" class="d-flex justify-start align-content-center">
                                        <v-autocomplete dense outlined
                                            label="famiglia"
                                            v-model="filter.search_family"
                                            :items="Object.values(families).filter(f => { return f.enabled})"
                                            item-text="label"
                                            item-value="id"
                                            multiple
                                            clearable></v-autocomplete>
                                    </v-col>
                                    <v-col cols="6" class="d-flex justify-start align-content-center pl-2">
                                        <v-text-field dense outlined
                                            label="seriale/marca/modello"
                                            v-model="filter.search"
                                            clearable></v-text-field>
                                    </v-col>
                                </v-row>
                                <!--div class="font-weight-bold">Data scadenza</div>
                                <v-row no-gutters>
                                    <v-row no-gutters>
                                        <v-col cols="6" class="d-flex justify-start align-content-center pr-2">
                                            <v-autocomplete dense outlined
                                                label="tipo report" 
                                                :items="op_types"
                                                item-value="id"
                                                item-text="name"
                                                v-model="filter.op_type"
                                                clearable></v-autocomplete>
                                        </v-col>
                                    </v-row>
                                    <v-col cols="12" class="d-flex flex-column">
                                        <div class="d-flex justify-left full-width my-2">
                                            <v-btn class="" @click="periodChange(0, 0)">oggi</v-btn>
                                            <v-btn class="ml-2" @click="periodChange(1, 1)">ieri</v-btn>
                                            <v-btn class="ml-2" @click="periodChange(6, 0)">ultimi 7 giorni</v-btn>
                                            <v-btn class="ml-2" @click="periodChange(29, 0)">ultimi 30 giorni</v-btn>
                                        </div>
                                        <div class="d-flex mt-1">
                                            <span><CalendarField
                                                v-model="filter.from"
                                                label="da"
                                                clearable>
                                            </CalendarField></span>
                                            <span class="pl-2"><CalendarField
                                                v-model="filter.to"
                                                label="a"
                                                clearable>
                                            </CalendarField></span>
                                        </div>
                                    </v-col>
                                </v-row-->
                                
                                <v-row no-gutters>
                                    <v-col cols="12" class="d-flex justify-center align-content-center">
                                        <v-btn color="primary" class="text-center" @click="search"><v-icon class="ma-2">search</v-icon>cerca</v-btn>
                                        <v-btn color="action" class="text-center ml-2" @click="cancelSearch">annulla</v-btn>
                                    </v-col>
                                </v-row>
                                </div>
                                <v-row no-gutters>
                                    <v-col cols="12" class="d-flex flex-row justify-space-between align-content-center mt-4">
                                        <span><v-autocomplete dense outlined
                                                label="ordina per"
                                                v-model="sort_fields"
                                                :items="sorting_fields"
                                                item-value="value"
                                                item-text="label"
                                                return-object
                                                hide-details
                                                @change="changeOrder"
                                            ></v-autocomplete>
                                        </span>
                                        <span v-if="!advanced_search"><v-btn color="primary" @click.stop="openAdvancedSearch"><v-icon class="mr-2">filter_list</v-icon>filtra</v-btn></span>
                                    </v-col>
                                </v-row>
                
                                <!------------------------------------------------------------------>
                                <v-row no-gutters v-for="instr in objects" :key="instr._id">
                                    <OpInstrumentItem
                                        :instrument_id="instr._id"
                                        :location="location"
                                        :override_location="all_instrument"
                                        :show_platform_capacity="true"
                                        :key="instr._id">
                                        <template v-slot:item_action>
                                            <v-checkbox 
                                                class="ma-0" 
                                                hide-details 
                                                :value="instr._id" 
                                                :disabled="locked_instr.includes(instr._id)"
                                                v-model="instrument_ids">
                                            </v-checkbox>
                                        </template>
                                    </OpInstrumentItem>
                                </v-row>
                            </v-container>
                        </v-tab-item>
                    </v-tabs-items>
                </v-col>
            </v-row>
            <InstrumentDialog
                v-if="client_id"
                ref="instrumentEdit"
                :client_id="client_id"
                :location_id="location_id"
                :lock_client="true"
                :org_id="operation_org_id"
                v-bind:client_name="client.name"
                v-on:update_instrument="instrumentAdded"
            />
            <AddDepartment
                v-if="location_id"
                ref="departmentEdit"
                :location_id="location_id"
                :contacts="Object.values(client.contacts)"
                v-on:add_department="departmentAdded"/>

        </v-container>
    </div>
</template>
<script>
// import _ from 'lodash'

import {ListManagement} from "../../utils/listMixin"
import AddDepartment from "../clients/AddDepartmentDialog"
import InstrumentDialog from "../instruments/InstrumentDialog"
import OpInstrumentItem from "./OpInstrumentItem"
import { searchDesign } from "../../utils/dbUtility"
import { i_families } from "../../utils/common"


export default {
    components: {AddDepartment, InstrumentDialog, OpInstrumentItem},
    mixins: [ListManagement],
    props: {
        client_id: {
            type: String,
            required: true
        },
        location_id: {
            type: String,
            required: true
        },
        operation_org_id: {
            type: String,
            required: true
        },
        show_platform_capacity: {
            type: Boolean,
            required: false,
            default: false
        },
        selected_departments: {
            type: Array,
            required: false,
            default: null
        },
        selected_instruments: {
            type: Array,
            required: false,
            default: null
        },
        lock_inst_reports: {
            type: Boolean,
            required: false,
            default: false
        },
        operation_id: {
            type: String,
            required: false,
            default: null
        },
        o_all_instrument: {
            type: Boolean,
            required: false,
            default: false
        },
        op_type: {
            type: String,
            required: false,
            default: null
        }
    },
    data(){
        return {
            families: i_families,
            tab: 'selection',
            db: 'registry',
            o_selector: {doc_type:'instrument', dismissed: false, visible: true},
            selector: {},
            fields: ['_id', 'metro_data.iso.next_operation','metro_data.lat.next_operation','metro_data.leg.next_operation','metro_data.iso_simple.next_operation', 'client_id', 'location_id', 'deparment_id', 'family', '_rev'],
            department_ids: [],
            instrument_ids:[],
            instruments: [],
            all_instrument: false,
            client: {},
            location: {},
            locations: [],
            loading: true,
            sort_fields: {label: 'scadenza', value: ['value.exp', 'value.name'], order: ['asc', 'asc']},
            sort_asc: false,
            locked_instr: [],
            filter: {
                client_id: this.client_id,
                location_id: this.location_id,
                department_id: null,
                search_family: [],
                search: ""
            },
            filtered_search: false,
            sorting_fields: [
                {label: 'scadenza', value: ['value.exp', 'value.name', 'value.serno'], order: ['asc', 'asc']},
                {label: 'modifica', value:['value.updated', 'value.name', 'value.serno'], order: ['desc', 'asc']},
                {label: 'nome/codice cliente', value: ['value.name', 'value.serno', 'value.exp'], order: ['asc', 'asc']},
                {label: 'seriale', value: ['value.serno', 'value.name', 'value.exp'], order: ['asc', 'asc']},
                {label: 'famiglia', value: ['value.family', 'value.exp', 'value.name'], order: ['asc', 'asc']}
            ],
            list_type: 'instrument', 
            loc_selected_dep: []
        }
    },
    async mounted() {
        this.loading = true
        this.client = await this.$store.state.$pouch.get('registry', this.client_id)
        this.location = await this.$store.state.$pouch.get('registry', this.location_id)
        this.departments = Object.values(this.location.departments)
        let loc_deps = Object.keys(this.location.departments)
        this.loc_selected_departments = this.selected_departments.filter(dep => loc_deps.includes(dep))
        if(this.loc_selected_departments) {
            this.department_ids = [...this.loc_selected_departments]
        }
        if(this.selected_instruments) {
            this.instrument_ids = [...this.selected_instruments]
        }
        this.all_instrument = this.o_all_instrument
        await this.updateSearch()
        if (this.lock_inst_reports && this.operation_id) {
            let res = await searchDesign(this.$store.state.$pouch, 'reports', 'reports/searchByData', 'all_keys', [['operation', this.operation_id], ['client', this.client_id]], false)
            this.locked_instr = _.map(res, function(doc) {
                console.log(doc.value.instrument_id)
                return doc.value.instrument_id
            });
        }
        this.loading = false
    },
    methods: {
        initSelector() {
            this.o_selector.client_id = this.client_id
            console.log('o_selector', this.o_selector)
        },
        customSelection(){
            // to be implemented with search
            // use selector to change selection
            // if (!this.all_instrument) {
            //     this.selector.location_id = this.location_id
            //     if (this.department_ids.length > 0) {
            //         this.selector.department_id = {'$in': this.department_ids}
            //     }
            // } else {
            //     console.log('çççççççççççççççç', this.all_instrument)
            //     delete this.selector.location_id
            //     delete this.selector.department_id
            // }

            // console.log('selector', this.selector)
        },
        async loadLocations() {
            let res = await searchDesign(this.$store.state.$pouch, 'registry', 'registry/searchByData', 'key', ['client', this.client_id], false)
            this.locations = res
        },
        async getDepartments() {
            if (this.filter.location_id) {
                let location = await this.$store.state.$pouch.get("registry", this.filter.location_id)
                this.departments = Object.values(location.departments)
            } else {
                this.filter.department_id = null
                this.departments = []
            }
        },
        async updateSearch() {
            let res = []
            var selectors = []
            if (this.advanced_search) {
                let selectors = [['client', this.filter.client_id]]
                let f_keys = [...Array(this.filter.search_family.length)].map((_, i) => ['family', this.filter.search_family[i]])
                let multiple_fam = false
                if (f_keys.length >0) { 
                    if (f_keys.length == 1 ){
                        selectors.push(f_keys[0])
                    } else {
                        multiple_fam = true
                    }
                }
                if (this.filter.location_id) {
                    selectors.push(['location', this.filter.location_id])
                }
                if (this.filter.department_id) {
                    selectors.push(['department', this.filter.department_id])
                }
                if (this.filter.org){
                    selectors.push(['org', this.$store.state.user.org_id])
                }
                res = await this.searchFromDesignNew('instruments/searchByData', 'all_keys', selectors, false)
                if (multiple_fam) {
                    let f_instrs = await this.searchFromDesignNew('instruments/searchByData', 'keys', f_keys, false)
                    //console.log("fam search" ,f_instrs)
                    res = _.intersectionWith(res, f_instrs, function(arrVal, othVal){
                        return arrVal._id == othVal._id
                    })
                }
                if (this.filter.search) {
                    let text_res = await this.searchFromDesignNew('instruments/searchByText', 'text', this.filter.search, false)
                    res = _.intersectionWith(res, text_res, function(arrVal, othVal){
                        return arrVal._id == othVal._id
                    })
                }
                // console.log('intersection', res)
            } else {
                if (this.all_instrument){
                    selectors = ['client', this.client_id]
                    res = await this.searchFromDesignNew('instruments/searchByData', 'key', selectors, false)
                } else {
                    if (this.department_ids.length > 0) {
                        for (let dep of this.department_ids) {
                            selectors.push([this.location_id, dep])
                        }
                        res = await this.searchFromDesignNew('instruments/searchByData', 'keys', selectors, false)    
                    } else {
                        selectors = ['location', this.location_id]
                        res = await this.searchFromDesignNew('instruments/searchByData', 'key', selectors, false)
                    }             
                }
            }
            if (this.op_type) {
                let fam = []
                for (let key of Object.keys(this.families)) {
                    if (Object.keys(this.families[key].report).includes(this.op_type)) {
                        fam.push(key)
                    }
                }
                console.log('FAM', fam)
                res = res.filter((item) => {
                    console.log(item)
                    return fam.includes(item.value.family)
                });
            }
            this.objects = this.orderBy(res, this.sort_fields)
        },
        async searchForComparators(){
            let selector = {
                selector: {
                    doc_type: 'instrument',
                    primary: true,
                    used_by: this.$store.state.user.org_id,
                    dismissed: false,
                    family: "bilancia nawi"
                }
            }
            let res = await this.$store.state.$pouch.find("registry", selector)
            this.objects = res.docs
        },
        resetSearch(){
            this.filter = {
                client_id: this.client_id,
                location_id: null,
                department_id: null,
                search_family: [],
                search: ""
            }
            this.$store.commit('setSearchParam', {path: this.$router.history.current.fullPath, filter: null})
        },
        instrumentAdded(instr_id) {
            this.$set(this.instrument_ids, this.instrument_ids.length, instr_id)
            // this.instrument_ids.push(instrument._id)
            this.updateSearch()
        },
        getData() {
            return {
                instrument_ids: this.instrument_ids,
                all_instrument: this.all_instrument,
                department_ids: this.department_ids
            }
        },
        addNewInstrument(){
            // TODO open a new dialog to edit the location
             let data = {
                client_id: this.client_id,
                location_id: this.location_id,
                org_id: this.operation_org_id,
                lock_client: true,
                instrument_id: null
             }
            this.$refs.instrumentEdit.openDialog(data);
        },
        addNewDepartment(){
            this.$refs.departmentEdit.openDialog();
        },
        async departmentAdded(department) {
            this.location = await this.$store.state.$pouch.get('registry', this.location_id)
            this.department_ids.push(department.id)
        },
        removeInstrumentFromSelection(instr_id) {
            let idx = this.instrument_ids.indexOf(instr_id)
            this.instrument_ids.splice(idx, 1)
            console.log('REMOVE FROM SELECTION', instr_id)
        },
    },
    watch: {
        all_instrument() {
            console.log('ALL INSTRUMENT CHANGED')
            //this.customSelection()
            //this.findObjects()
            if (this.all_instrument) {
                this.loadLocations()
            }
            this.updateSearch()
        }
    }
    
}

</script>